import {UntypedFormGroup} from '@angular/forms';
import {IndexedMapPosition, MapPosition} from '../../../../route/metamodel';
import LatLng = google.maps.LatLng;
import {VehiclePosition} from '../../../../../../../core/component/latest-vehicles-info/vehicle-position';

export class ProTasksFormRouteUtils {

  public static getNewTaskIndex(
    forms: UntypedFormGroup[],
    lat: number,
    lng: number,
    position: VehiclePosition): number {

    let destinationIndexes = [];
    let routeLatLng = [];
    forms.forEach(it => {
      let route = google.maps.geometry.encoding.decodePath(it.controls.truckRoute.value);
      routeLatLng = routeLatLng.concat('EXECUTING' === it.controls.status.value
        ? this.removeExecutedRoute(route, position)
        : route);
    });
    forms.forEach(it => {
      let latLng = new google.maps.LatLng(
        it.controls.destinationPosition.value.lat,
        it.controls.destinationPosition.value.lng);
      destinationIndexes.push(this.pointIndex(routeLatLng, latLng));
    });
    let newTaskIndex = this.pointIndex(routeLatLng, new google.maps.LatLng(lat, lng));
    return this.resolveNewIndex(newTaskIndex, destinationIndexes);
  }

  private static removeExecutedRoute(route: LatLng[], position: VehiclePosition): LatLng[] {
    let index = this.pointIndex(route, new LatLng(position.latitude, position.longitude));
    return index !== -1
      ? route.slice(index)
      : route;
  }

  public static pointIndex(routeLatLng: google.maps.LatLng[], latLng: google.maps.LatLng) {
    let diffArray = [];
    for (let point of routeLatLng) {
      let elementDifference = this.elementDifference(routeLatLng, point, latLng);
      diffArray.push(elementDifference);
    }
    diffArray.sort((a, b) => a.diff > b.diff ? 1 : -1);
    return diffArray.length > 0 ? diffArray[0].idx : -1
  }

  private static elementDifference(
    routeLatLng: google.maps.LatLng[],
    point: google.maps.LatLng,
    location: google.maps.LatLng) {

    let diff = Math.abs(location.lat() - point.lat()) + Math.abs(location.lng() - point.lng());
    let idx = routeLatLng.indexOf(point);
    return {
      diff: diff,
      idx: idx
    }
  }

  private static resolveNewIndex(newTaskIndex: number, destinationIndexes: any[]) {
    let index = 0;
    for (let i = 0; i < destinationIndexes.length; i++) {
      if (destinationIndexes[i] > newTaskIndex) {
        index = i;
        break;
      } else if ( destinationIndexes[i] === newTaskIndex || destinationIndexes[i] < newTaskIndex) {
        index = destinationIndexes.length
      }
    }
    return index;
  }

  public static getSortedWayPoints(form: UntypedFormGroup, lat: number, lng: number) {
    let wayPointsMap = new Map<number, google.maps.LatLng>();
    let routeLatLng = google.maps.geometry.encoding.decodePath(form.controls.truckRoute.value);
    form.controls.waypoints.value.forEach(it => {
      let latLng = new google.maps.LatLng(it.lat, it.lng);
      wayPointsMap.set(this.pointIndex(routeLatLng, latLng), latLng)
    });
    let newTaskIndex = this.pointIndex(routeLatLng, new google.maps.LatLng(lat, lng));
    return this.sortWayPoints(wayPointsMap, newTaskIndex);
  }

  private static sortWayPoints(wayPointsMap: Map<number, google.maps.LatLng>, newTaskIndex: number) {
    let oldTaskWaypoints = [];
    let newTaskWaypoints = [];
    let wayPointsIndexes = Array.from(wayPointsMap.keys());
    for (let i = 0; i < wayPointsIndexes.length; i++) {
      wayPointsIndexes[i] > newTaskIndex
        ? newTaskWaypoints.push(wayPointsMap.get(wayPointsIndexes[i]))
        : oldTaskWaypoints.push(wayPointsMap.get(wayPointsIndexes[i]))
    }
    return {old: oldTaskWaypoints, new: newTaskWaypoints};
  }

  public static resolveTrafficMarkerPosition(polyline: any) {
    let polylineLatLngs = google.maps.geometry.encoding.decodePath(polyline);
    return polylineLatLngs[Math.floor(polylineLatLngs.length / 2)];
  }

  public static resolveTrafficType(type: string) {
    return type === 'congestion' || type === 'flow'
      ? 'CONGESTION'
      : type.toUpperCase();
  }

  public static resolveTrafficIntensity(criticality: any) {
    switch (criticality) {
      case 0:
        return '#C50006';
      case 1:
        return '#FF2600';
      case 2:
        return '#FFA200';
      case 3:
        return '#FFDB00'
    }
  }

  public static sortWaypoints(polyline: string, waypoints: MapPosition[]): MapPosition[] {
    let coordinates: LatLng[] = google.maps.geometry.encoding.decodePath(polyline);
    let indexedWaypoints: IndexedMapPosition[] = [];
    for (let waypoint of waypoints) {
      let idx = this.pointIndex(coordinates, new google.maps.LatLng(waypoint.lat, waypoint.lng));
      indexedWaypoints.push({
        idx: idx,
        lat: waypoint.lat,
        lng: waypoint.lng
      });
    }
    return indexedWaypoints.sort((a, b) => a.idx > b.idx ? 1 : -1).map(it => {
      return {lat: it.lat, lng: it.lng}
    });
  }

  public static toPointKey(point: MapPosition): string {
    return point.lat + '_' + point.lng;
  }

  public static toPositionString(point: MapPosition): string {
    return point.lat + ',' + point.lng;
  }

  public static splitToMapPosition(data: any): Map<number, MapPosition> {
    let points: Map<number, MapPosition> = new Map<number, MapPosition>();
    Object.keys(data).forEach(key => {
        let lat = data[key].split('_')[0];
        let lng = data[key].split('_')[1];
        points.set(+key, { lat: +lat, lng: +lng, address: '' })
    });
    return points;
  }

}
